/* 🤖 this file was generated by svg-to-ts */
export const emperorIconBoxReply1: {
  name: 'box_reply_1';
  data: string;
} = {
  name: 'box_reply_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M2 8h16v2h2V7c0-.01-.01-.02-.01-.02 -.01-.12-.03-.23-.07-.34 -.02-.03-.03-.06-.04-.08 -.02-.04-.04-.08-.06-.12l-4-6c-.19-.28-.5-.45-.84-.45h-10c-.34 0-.65.167-.84.445l-4 6c-.03.03-.04.07-.06.11 -.02.02-.03.05-.04.08 -.05.1-.066.22-.068.33 -.001 0-.01.01-.01.01v12c0 .55.447 1 1 1h7v-2h-6v-10Zm15.13-2h-6.14V2h3.465l2.66 4ZM5.53 2H8.99v4H2.86l2.66-4Z"/><path d="M18 16h-4.586l2.29-2.3 -1.42-1.42 -4.71 4.7 4.7 4.7 1.41-1.42 -2.3-2.3h4.586c2.2 0 4 1.79 4 4v2h2v-2c0-3.31-2.7-6-6-6Z"/></g></svg>`,
};
